// // src/hooks/useFadeInScroll.ts
// import { useEffect, useRef, useState } from "react";

// export const useFadeInScroll = <T extends HTMLElement>(
//   threshold = 0.25
// ) => {
//   const ref = useRef<T | null>(null);
//   const [isVisible, setIsVisible] = useState(false);
//   const [hasMounted, setHasMounted] = useState(false);

//   // mark that the component has mounted for initial animation
//   useEffect(() => {
//     setHasMounted(true);
//   }, []);

//   useEffect(() => {
//     const node = ref.current;
//     if (!node) return;

//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         setIsVisible(entry.isIntersecting);
//       },
//       {
//         threshold,
//         rootMargin: "-80px 0px -80px 0px", // triggers a bit before leaving viewport
//       }
//     );

//     observer.observe(node);

//     return () => observer.disconnect();
//   }, [threshold]);

//   return { ref, isVisible, hasMounted };
// };


// -----2-----

// src/hooks/useFadeInScroll.ts
// import { useEffect, useRef, useState } from "react";

// export const useFadeInScroll = <T extends HTMLElement>(
//   threshold = 0.25
// ) => {
//   const ref = useRef<T | null>(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const node = ref.current;
//     if (!node) return;

//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         // 🔥 Trigger ONCE only
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//           observer.unobserve(entry.target); // stop observing
//         }
//       },
//       {
//         threshold,
//         rootMargin: "0px 0px -80px 0px",
//       }
//     );

//     observer.observe(node);

//     return () => observer.disconnect();
//   }, [threshold]);

//   return { ref, isVisible };
// };


// -----3----
// src/hooks/useFadeInScroll.ts
import { useEffect, useRef, useState } from "react";

type FadeOptions = {
  enterThreshold?: number; // when animation should trigger
  exitThreshold?: number;  // when animation should reset
};

export const useFadeInScroll = <T extends HTMLElement>({
  enterThreshold = 0.35,
  exitThreshold = 0.15,
}: FadeOptions = {}) => {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const ratio = entry.intersectionRatio;

        // ✅ Enter animation
        if (!isVisible && ratio >= enterThreshold) {
          setIsVisible(true);
        }

        // ✅ Exit animation (buffered)
        if (isVisible && ratio <= exitThreshold) {
          setIsVisible(false);
        }
      },
      {
        threshold: [exitThreshold, enterThreshold],
        rootMargin: "0px 0px -80px 0px",
      }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [enterThreshold, exitThreshold, isVisible]);

  return { ref, isVisible };
};
